export function salaryCatRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SALARY_CAT_START":           
        case "FETCH_SALARY_CATS_START":                                 
        case "UPDATE_SALARY_CAT_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_SALARY_CAT_FULFILLED":           
        case "FETCH_SALARY_CATS_FULFILLED":                                 
        case "UPDATE_SALARY_CAT_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_SALARY_CAT_ERROR":
        case "FETCH_SALARY_CATS_ERROR":
        case "UPDATE_SALARY_CAT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}